import axiosInstance from './axios';
import { API_URL } from '../config/api';

export const authService = {
  login: async (userid, password) => {
    const response = await axiosInstance.post('/api/login', {
      userid,
      password
    });
    return response.data;
  },

  validateToken: async () => {
    const response = await axiosInstance.post('/api/validate-token');
    return response.data;
  }
};
